export const terminationSteps = [
    'unsupportedRegion',
    'unsupportedRoofMaterial'
];
export const DEFAULT_ERROR_MESSAGE = 'Bitte überprüfen Sie Ihre Eingabe';

//# sourceMappingURL=b2b-funnel-embed.consts.js.map